/**
 * Die Planungsphase als Quelle für die KI-Kontexte — fail-open.
 *
 * Plan-, Handbuch- und Koordinierungs-Assistent sowie der UfsA-Katalog reichen
 * die Merkmale und die Baubeschreibung der Planungsphase an das Modell weiter
 * (`planungKontext` in `aiAssistContext.ts`). Sie ist dafür eine QUELLE und
 * keine Voraussetzung: ein Projekt ohne Planungsphase, eine fehlende Tabelle
 * oder ein Lesefehler lässt den Assistenten so arbeiten wie vor diesem
 * Baustein — mit `planung: null` im Kontext.
 *
 * Deshalb hier ein eigener, kleiner Leseweg statt `fetchPlanungsphase`
 * unmittelbar in den Aufrufern: der Fang steht an EINER Stelle, und kein
 * Aufrufer kann vergessen, dass dieser Lesefehler keiner ist, der das
 * Assistenzfenster schließen darf. Angelegt wird nichts — `ensurePlanungsphase`
 * bleibt der Planungsphase selbst vorbehalten.
 */

import { fetchPlanungsphase } from './planungsphaseService';
import type { Planungsphase } from '../components/planungsphase/types';

/** Die Planungsphase eines Projekts, oder `null` — auch im Fehlerfall. */
export const ladePlanungsphaseFuerKi = async (projectId: string): Promise<Planungsphase | null> => {
    if (!projectId) return null;
    try {
        return await fetchPlanungsphase(projectId);
    } catch (e) {
        // Sichtbar in der Konsole, unsichtbar für den Anwender: der Kontext
        // ist ohne Planungsphase schlechter, aber nicht falsch.
        console.warn('Planungsphase für den KI-Kontext nicht lesbar — der Assistent läuft ohne sie.', e);
        return null;
    }
};
